import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { WebSocketProvider } from './context/WebSocketContext';
import { AlphalendWebSocketProvider } from './context/AlphalendWebSocketContext';
import { NETWORKS } from './utils/config';
import { runtimeConfig } from './utils/runtimeConfig';
import App from './App';
import './index.css';
import 'ui-kit/dist/main.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SuiClientProvider, WalletProvider } from '@mysten/dapp-kit';
import { NetworkProvider } from './context/NetworkContext';
import { BalanceProvider } from './context/BalanceContext';
const queryClient = new QueryClient();
// Get the default network from runtime config
const defaultNetwork = runtimeConfig.getDefaultNetwork();
const root = createRoot(document.getElementById('root'));
root.render(_jsx(QueryClientProvider, { client: queryClient, children: _jsx(SuiClientProvider, { networks: NETWORKS, defaultNetwork: defaultNetwork, children: _jsx(WalletProvider, { autoConnect: true, slushWallet: { name: 'Alphafi' }, children: _jsx(WebSocketProvider, { children: _jsx(AlphalendWebSocketProvider, { children: _jsx(NetworkProvider, { children: _jsx(BalanceProvider, { children: _jsx(App, {}) }) }) }) }) }) }) }));
